module.exports = __webpack_public_path__ + "80bd2dec8d8c559d2e7be78fe93752f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/caseyaffleck.jpg
// module id = 137
// module chunks = 0